import { ReactNode } from 'react';

import { Card } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  cardList: ReactNode;
  mainContent: ReactNode;
  isBulkPublish?: boolean;
};

const TabLayout = ({ cardList, mainContent, isBulkPublish }: Props) => {
  return (
    <div
      className={cn(
        'flex flex-row gap-4',
        isBulkPublish
          ? 'h-[calc(100vh-330px)]' // Bulk publish toolbar with paddings
          : 'h-[calc(100vh-258px)]',
      )}
    >
      <div className="h-full w-[28%] min-w-102.5 shrink-0">{cardList}</div>

      <Card
        variant="outlined"
        className="flex h-full grow justify-center"
        contentClassName="w-full h-full"
      >
        {mainContent}
      </Card>
    </div>
  );
};

export default TabLayout;
